
import React from 'react';

const Point = (isActivePoint) => {
  return (<div className={"ligne-active " + (isActivePoint ? isActivePoint.toLowerCase() : "active")}/>)
}
export default Point;



// WEBPACK FOOTER //
// ./src/components/MyServices/ActivePoint.js